import React from 'react'
import "../App.css"
import image from "../Assets/imgs/Logov1_32x32.png"

function Navbar({
    navTitle, navLinkOneTitle, navLinkTwoTitle, navLinkThreeTitle, navLinkFourTitle,
    navLinkOneSource, navLinkTwoSource, navLinkThreeSource, navLinkFourSource })
    {

    const navWrapperStyles = {
        position: "absoulute",
        height: "50px",
        width: "100%",
        display: "flex", // inline or flex
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "#2a2a2a",
        zIndex: 9999999999
        // overflow: "hidden"
    }

    // display: "inline-flex",
    // height: "5.8%",
    // width: "100%",
    // backgroundColor: "#2a2a2a",
    // borderBottom: "4px #232323",
    // zIndex: 1,
    // lineHeight: "3%",
    
    const navContainer = {
        // display: "inline", // inline or flex
        // display: "flex"
        zIndex: 9999999999
    };

    const navLogoStyles = {
        height: 32,
        width: 32,
        padding: "9px",
        float: "left",
        display: "flex"
        
    };

    const navNameStyles = {
        marginLeft: 3,
        position: "inline",
        float: "right",
        fontSize: 23,
        lineHeight: "20px",
        color: "#B03131"
    };

    const navLinksContainer = {
        // marginLeft: 135,
        position: "inline",
        float: "right",
        // fontSize: 23,
        // lineHeight: "20px", // add back
        // color: "#B03131"
        zIndex: 9999999999
    };

    return (
        <div style={{ display: "fixed", zIndex: 9999999999 }}>
            <div id='st-skytracker-nav' style={navWrapperStyles}>
                <div id="st-nav-container">
                    <div id="st-nav-logo-text-container">
                        <img style={navLogoStyles} src={image} alt={navTitle} />
                        <h1 style={navNameStyles}>{navTitle}</h1>
                    </div>
                    <div>
                        <a href={navLinkOneSource}   style={navLinksContainer}>{navLinkOneTitle}</a>
                        <a href={navLinkTwoSource}   style={navLinksContainer}>{navLinkTwoTitle}</a>
                        <a href={navLinkThreeSource} style={navLinksContainer}>{navLinkThreeTitle}</a>
                        <a href={navLinkFourSource}  style={navLinksContainer}>{navLinkFourTitle}</a>
                    </div>
                </div>
            </div>    
        </div>
    )
}

export default Navbar
